import { PRODUCT } from 'utils/constants';
import {
  isICICIDashboard,
  isLKDashboard,
  isIDFCDashboard,
  isAxisDashboard,
} from 'utils/common';
import {
  getCustomCreatedSmartRules,
  getRecommendedSmartRules,
} from 'services/riskShield';

import { productMapping, APPROVED, UNDER_REVIEW } from './constants';

export const getProductMappedObjects = () => {
  if (isICICIDashboard() || isIDFCDashboard()) {
    return {
      [PRODUCT.PAYMENT_GATEWAY]: productMapping[PRODUCT.PAYMENT_GATEWAY],
      [PRODUCT.AUTO_COLLECT]: productMapping[PRODUCT.AUTO_COLLECT],
      [PRODUCT.PAYMENT_LINK]: productMapping[PRODUCT.PAYMENT_LINK],
    };
  }
  if (isLKDashboard()) {
    return {
      [PRODUCT.PAYOUT]: productMapping[PRODUCT.PAYOUT],
    };
  }
  if (isAxisDashboard())
    return {
      [PRODUCT.PAYMENT_GATEWAY]: productMapping[PRODUCT.PAYMENT_GATEWAY],
      [PRODUCT.PAYMENT_LINK]: productMapping[PRODUCT.PAYMENT_LINK],
      [PRODUCT.PAYMENT_FORM]: productMapping[PRODUCT.PAYMENT_FORM],
    };
  return productMapping;
};

export const getEPOSStatus = ({ PG, EPOS }) => {
  // Access button to be given only if PG is APPROVED and EPOS is APPROVED
  if (EPOS === APPROVED) return PG === APPROVED ? APPROVED : UNDER_REVIEW;
  return EPOS;
};

export const initialiseSurveySparrow = ({ email }) => {
  if (email) {
    if (typeof window.SparrowLauncher !== 'function') {
      return;
    }

    window.SparrowLauncher('popup', {
      email,
      variables: {},
      disableDebugLog: false,
    });

    const surveyListener = e => {
      if (e && e.data && e.data.type === 'surveyCompleted') {
        window.postMessage({ type: 'removeWindow' }, '*');
        window.removeEventListener('message', surveyListener);
      }
    };

    window.addEventListener('message', surveyListener);
  }
};

export const getPGActiveSmartRulesCount = async () => {
  try {
    const recommendedSmartRules = await getRecommendedSmartRules();
    const customSmartRules = await getCustomCreatedSmartRules({
      queryObj: {
        fetchType: 'CUSTOM',
        product: 'PG',
      },
    });

    const activeRecommendedSmartRulesCount = Object.values(
      recommendedSmartRules,
    )
      .flat()
      .filter(rule => rule?.active).length;
    const activeCustomSmartRules = Object.values(customSmartRules).filter(
      item => item.isActive,
    ).length;

    const activeSmartRulesCount =
      activeRecommendedSmartRulesCount + activeCustomSmartRules;
    return activeSmartRulesCount;
  } catch (error) {
    console.error(error);
    return null;
  }
};
